module.exports = "/_next/static/images/ManToManDiagnosis-9564984ab7301f4494fe5835483f6f48.png";